<ng-container *transloco="let _t">

<div class="action" [ngClass]="{
	'statusCanceled': action.actionStatus==-2,
	'statusNew': action.actionStatus==-1,
	'statusTODO':action.actionStatus==0,
	'statusWIP':action.actionStatus==1,
	'statusFINISHED':action.actionStatus==2,
	'fold': fold
}">

	<div class="header">

		<!--Nom action-->
		<h3>
			<auto-editable 
				[value]="action.actionName" 
				[edit]="action.actionStatus==-1"
				(changeValue)="changeActionName($event)" 
				(cancel)="changeActionName(null)"
				type="text"
				[placeholder]="_t('rm-action-placeholder-0')"></auto-editable>
		</h3>

		<div *ngIf="action.actionStatus>=0">
		<!--Dates-->
		<div class="dates">
			<label>{{ _t('rm-action-label-0') }}</label>
			<div class="datePickerFormField">
				<mat-date-range-input [rangePicker]="picker">
				<input matStartDate [(ngModel)]="action.  startDate" />
				<input matEndDate [(ngModel)]="action.endDate" />
				</mat-date-range-input>
				
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</div>
		</div>
		<div class="budget">
			<label>{{ _t('rm-action-label-1') }} </label>		
			<auto-editable 
			[value]="action.actionBudget" 
			(changeValue)="action.actionBudget=$event" 
			type="text"
			[placeholder]="_t('rm-action-placeholder-1')"></auto-editable> &nbsp; €
		</div>
		<!--Team-->
		<rm-team
			[id]="singleView ? 'openedActionTeam' : 'actionTeamK'+action.id"
			[connectedLists]="connectedUserList"
			[users]="action.users"
			[deleteOnDragOut]="true"
			(changeValue)="action.users=$event"></rm-team>

		</div>
		<!-- action Toolbar -->
		<div class="actiontoolbar toolbar" *ngIf="singleView">
			<button
				mat-mini-fab color="warn" class="singleView right" 
				(click)="close()" [title]="_t('rm-action-title-0')">
				<mat-icon>close</mat-icon> 
			</button>
			<!-- REVOIR POUR LES STATUS -->
			<br>
			<div *ngIf="action.actionStatus>=0">
			<span *ngFor="let s of [0,1,2]" (click)="changeStatus(s)">
				{{ action.getStringStatus(s) }}
				<button mat-mini-fab
					[color]="disabled"
					class="nextStatus right" 
					[ngClass]="{
						'statusTODO':s==0,
						'statusWIP':s==1,
						'statusFINISHED':s==2
					}">
				
					<mat-icon *ngIf="s==action.actionStatus">radio_button_checked</mat-icon>
					<mat-icon *ngIf="s!=action.actionStatus">radio_button_unchecked</mat-icon>
				</button>
				<br>
			</span>
			</div>
			<!-- -->
		</div>

		<!-- content Toolbar-->
		<div class="contenttoolbar toolbar" *ngIf="action.actionStatus>=0">
			<!-- content buttons -->
			<button *ngIf="!action.jsonDetails.todo && action.actionStatus>=0"
					mat-mini-fab class="contentBtn" color="primary"
					[title]="_t('rm-action-title-1')"
					(click)="switchTODO()">
				<mat-icon>check_circle_outline</mat-icon>
			</button>
			<span *ngIf="action.jsonDetails.todo"
					[title]="_t('rm-action-title-2')">
				&nbsp;
				<mat-icon>check_circle_outline</mat-icon>
				{{action.todoFraction}}
			</span>
			&nbsp;

			<button *ngIf="!action.jsonDetails.comments && action.actionStatus>=0"
					mat-mini-fab class="contentBtn" color="primary"
					[title]="_t('rm-action-title-3')"
					(click)="switchComments()">
				<mat-icon>comment</mat-icon>
			</button>
			<span *ngIf="action.jsonDetails.comments"
					[title]="'Nombre de notes : '+action.commentsCount">
				&nbsp;
				<mat-icon>comment</mat-icon>
				{{action.commentsCount}}
			</span>
			&nbsp;

			<!-- (un)fold button -->
			<button *ngIf="!singleView"
				mat-mini-fab class="foldBtn right" color="disabled"
				(click)="fold=!fold" >
				<mat-icon *ngIf="fold" [title]="_t('rm-action-title-4')">arrow_drop_down</mat-icon>
				<mat-icon *ngIf="!fold" [title]="_t('rm-action-title-5')">arrow_drop_up</mat-icon>
			</button>

			<!-- form valid/cancel button 
			<button *ngIf="action.actionStatus==-1"
					mat-mini-fab class="contentBtn right" color="basic"
					[disabled]="!action.name"
					[title]="_t('rm-action-title-6')"
					(click)="saveNewAction()">
				<mat-icon>check</mat-icon>
			</button>
			&nbsp;
			<button *ngIf="action.actionStatus==-1"
					mat-mini-fab class="contentBtn right" color="warn"
					[title]="_t('rm-action-title-7')"
					(click)="close(false)">
				<mat-icon>clear</mat-icon>
			</button>
			-->
		</div>
	</div>
	
	<div class="content" [ngClass]="{'fold': fold, 'limited': singleView}">
	  <p><auto-editable *ngIf="action.actionStatus>=0"
			[value]="action.description"
			(changeValue)="action.description=$event" 
			type="textarea"
			[placeholder]="_t('rm-action-placeholder-2')"></auto-editable></p>

	  <mdr-checklist class="checklist" *ngIf="action.todo"
	  	[action]="action"
	  	[showTODO]="true"></mdr-checklist>
	  
	  <mdr-comments class="comments" *ngIf="action.comments"
	  	[action]="action"
	  	[showComments]="true"></mdr-comments>
	</div>

</div>

</ng-container>